<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [text]="'ZURUECK' | translate"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ 'PERSONALDOSSIER' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="padding-16">
    @if (isAdmin()) {
      @if (canCreate()) {
        <div class="flex justify-content-end margin-bottom-16">
          <work-ui-button (buttonClick)="openCreateModal()"
                          [text]="'PERSONALDOSSIER_NEUER_EINTRAG' | translate"
                          iconName="add" />
        </div>
      }

      @if (entries().length === 0) {
        <div class="work-text-align-center padding-32">
          <p>{{ 'PERSONALDOSSIER_KEINE_EINTRAEGE' | translate }}</p>
        </div>
      }

      <div class="flex flex-column gap-16">
        @for (entry of entries(); track entry.id) {
          <sfg-app-personaldossier-card
            [entry]="entry"
            [canEdit]="!!canUpdate()"
            [canDelete]="!!canDelete()"
            (editClick)="openEditModal($event)"
            (deleteClick)="deleteEntry($event)" />
        }
      </div>
    } @else {
      <div class="work-text-align-center padding-32">
        <p>{{ 'KEIN_ZUGRIFF' | translate }}</p>
      </div>
    }
  </div>

  @if (userId()) {
    <sfg-app-personaldossier-create-update-modal
      #modal
      [userId]="userId()!"
      (entryEdited)="loadEntries()" />
  }
</ion-content>
